import React from 'react'
import ReactSelect from './ReactSelect'

export default function SortSelect({ value, onChange, disabled }) {

  const sortOptions = [
    { label: 'Newest first', value: 'desc' },
    { label: 'Oldest first', value: 'asc' },
    { label: 'Default order', value: 'none' }
  ]

  return (
    <ReactSelect
      name="sort"
      onChange={onChange}
      value={value}
      options={sortOptions}
      disabled={disabled}
      isSearchable={true}
    />
  )
}

